import { queueMessage } from "~shared/snackbarsProvider/actions";
import { Action, createAction, handleActions } from "redux-actions";
import { DateRange } from "~api/types";
import { FechaField, Services } from "../types";
import { downloadFromUrl } from "../downloadFromUrl";

export interface GetAnulacionesState {
  fechaDesdeAnulacionesSelected: FechaField;
  fechaHastaAnulacionesSelected: FechaField;
  buttonEnabled: boolean;
  buttonText: string;
  errorMessage?: string;
}

const getAnulacionesInited = createAction(
  "GET_REPORTE_ANULACIONES_INITED",
  (data: DateRange) => ({ data })
);
const getAnulacionesCompleted = createAction(
  "GET_REPORTE_ANULACIONES_COMPLETED"
);
const getAnulacionesFailed = createAction(
  "GET_REPORTE_ANULACIONES_FAILED",
  (error: any) => ({ error })
);

const setFechaDesdeAnulaciones = createAction(
  "SET_FECHA_DESDE_ANULACION",
  (fechaDesdeAnulacionesSelected: FechaField) => ({
    fechaDesdeAnulacionesSelected,
  })
);
const setFechaHastaAnulaciones = createAction(
  "SET_FECHA_HASTA_ANULACION",
  (fechaHastaAnulacionesSelected: FechaField) => ({
    fechaHastaAnulacionesSelected,
  })
);

const date = new Date();
const defaultDesde = new Date(date.getFullYear(), date.getMonth(), 1);
const defaultHasta = new Date(date.getFullYear(), date.getMonth() + 1, 0);
const getAnulacionesInitialState: GetAnulacionesState = {
  fechaDesdeAnulacionesSelected: {
    value: defaultDesde,
    valid: true,
    focus: false,
  },
  fechaHastaAnulacionesSelected: {
    value: defaultHasta,
    valid: false,
    focus: false,
  },
  buttonEnabled: true,
  buttonText: "Descargar",
};

const getAnulacionesReducer = handleActions<GetAnulacionesState, any>(
  {
    [getAnulacionesInited.toString()]: (state) => {
      return {
        ...state,
        buttonEnabled: false,
        buttonText: "Descargando...",
      };
    },
    [getAnulacionesCompleted.toString()]: (state) => {
      return {
        ...state,
        buttonEnabled: true,
        buttonText: "Descargar",
      };
    },
    [getAnulacionesFailed.toString()]: (
      state,
      action: Action<{ error: any }>
    ) => {
      return {
        ...state,
        errorMessage: action.payload.error.responseStatus.message,
        buttonEnabled: true,
        buttonText: "Descargar",
      };
    },
    [setFechaDesdeAnulaciones.toString()]: (
      state,
      action: Action<{ fechaDesdeAnulacionesSelected: FechaField }>
    ) => {
      return {
        ...state,
        fechaDesdeAnulacionesSelected:
          action.payload.fechaDesdeAnulacionesSelected,
      };
    },
    [setFechaHastaAnulaciones.toString()]: (
      state,
      action: Action<{ fechaHastaAnulacionesSelected: FechaField }>
    ) => {
      return {
        ...state,
        fechaHastaAnulacionesSelected:
          action.payload.fechaHastaAnulacionesSelected,
      };
    },
  },
  getAnulacionesInitialState
);

const getAnulaciones = (data: DateRange) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getAnulacionesInited(data));
      const response = await services.api.reportes().getAnulaciones(data);

      downloadFromUrl(response.url);

      dispatch(getAnulacionesCompleted());
    } catch (error) {
      console.error(error);
      dispatch(getAnulacionesFailed(error));
      dispatch(
        queueMessage(
          "Ocurrió un error al descargar el reporte. Intente nuevamente."
        )
      );
    }
  };
};

export {
  getAnulaciones,
  getAnulacionesReducer,
  setFechaDesdeAnulaciones,
  setFechaHastaAnulaciones,
};
